/**
 * Maps aircraft registration prefixes to ISO 3166-1 alpha-2 country codes.
 *
 * Prefixes are sorted longest-first so the most specific match wins
 * (e.g. "B-H..." matches Hong Kong before the generic "B-" China rule).
 */

const REGISTRATION_PREFIXES = [
  // 4-char prefixes
  ['RDPL-', 'la'],
  // 3-char prefixes with sub-ranges (VP-x, VQ-x, VR-x, 9XR-)
  ['VP-B', 'bm'],
  ['VP-C', 'ky'],
  ['VP-F', 'fk'],
  ['VP-L', 'vg'],
  ['VQ-T', 'tc'],
  ['VR-B', 'bm'],
  ['9XR-', 'rw'],
  // 3-char prefixes
  ['A9C-', 'bh'],
  // 2-char prefixes (alphabetical by prefix)
  ['A2-', 'bw'],
  ['A3-', 'to'],
  ['A5-', 'bt'],
  ['A6-', 'ae'],
  ['A7-', 'qa'],
  ['AP-', 'pk'],
  ['C2-', 'nr'],
  ['C5-', 'gm'],
  ['C6-', 'bs'],
  ['C9-', 'mz'],
  ['CC-', 'cl'],
  ['CN-', 'ma'],
  ['CP-', 'bo'],
  ['CR-', 'pt'],
  ['CS-', 'pt'],
  ['CU-', 'cu'],
  ['CX-', 'uy'],
  ['D2-', 'ao'],
  ['D4-', 'cv'],
  ['D6-', 'km'],
  ['EC-', 'es'],
  ['EI-', 'ie'],
  ['EP-', 'ir'],
  ['ER-', 'md'],
  ['ES-', 'ee'],
  ['ET-', 'et'],
  ['EW-', 'by'],
  ['EX-', 'kg'],
  ['EZ-', 'tm'],
  ['H4-', 'sb'],
  ['HA-', 'hu'],
  ['HB-', 'ch'],
  ['HC-', 'ec'],
  ['HH-', 'ht'],
  ['HI-', 'do'],
  ['HK-', 'co'],
  ['HL-', 'kr'],
  ['HP-', 'pa'],
  ['HR-', 'hn'],
  ['HS-', 'th'],
  ['HZ-', 'sa'],
  ['J2-', 'dj'],
  ['J3-', 'gd'],
  ['J5-', 'gw'],
  ['J6-', 'lc'],
  ['J7-', 'dm'],
  ['J8-', 'vc'],
  ['JA-', 'jp'],
  ['JU-', 'mn'],
  ['JY-', 'jo'],
  ['LN-', 'no'],
  ['LV-', 'ar'],
  ['LX-', 'lu'],
  ['LY-', 'lt'],
  ['LZ-', 'bg'],
  ['OB-', 'pe'],
  ['OD-', 'lb'],
  ['OE-', 'at'],
  ['OH-', 'fi'],
  ['OK-', 'cz'],
  ['OM-', 'sk'],
  ['OO-', 'be'],
  ['OY-', 'dk'],
  ['P2-', 'pg'],
  ['P4-', 'aw'],
  ['PH-', 'nl'],
  ['PJ-', 'an'],
  ['PK-', 'id'],
  ['PP-', 'br'],
  ['PR-', 'br'],
  ['PT-', 'br'],
  ['PZ-', 'sr'],
  ['RA-', 'ru'],
  ['RF-', 'ru'],
  ['RP-', 'ph'],
  ['S2-', 'bd'],
  ['S5-', 'si'],
  ['S7-', 'sc'],
  ['S9-', 'st'],
  ['SE-', 'se'],
  ['SP-', 'pl'],
  ['ST-', 'sd'],
  ['SU-', 'eg'],
  ['SX-', 'gr'],
  ['T2-', 'tv'],
  ['T3-', 'ki'],
  ['T7-', 'sm'],
  ['T9-', 'ba'],
  ['TC-', 'tr'],
  ['TF-', 'is'],
  ['TG-', 'gt'],
  ['TI-', 'cr'],
  ['TJ-', 'cm'],
  ['TL-', 'cf'],
  ['TN-', 'cg'],
  ['TR-', 'ga'],
  ['TS-', 'tn'],
  ['TT-', 'td'],
  ['TU-', 'ci'],
  ['TY-', 'bj'],
  ['TZ-', 'ml'],
  ['UK-', 'uz'],
  ['UN-', 'kz'],
  ['UP-', 'kz'],
  ['UR-', 'ua'],
  ['V2-', 'ag'],
  ['V3-', 'bz'],
  ['V5-', 'na'],
  ['V7-', 'mh'],
  ['V8-', 'bn'],
  ['VH-', 'au'],
  ['VT-', 'in'],
  ['XA-', 'mx'],
  ['XB-', 'mx'],
  ['XC-', 'mx'],
  ['XT-', 'bf'],
  ['XU-', 'kh'],
  ['XY-', 'mm'],
  ['XZ-', 'mm'],
  ['YA-', 'af'],
  ['YI-', 'iq'],
  ['YJ-', 'vu'],
  ['YK-', 'sy'],
  ['YL-', 'lv'],
  ['YN-', 'ni'],
  ['YR-', 'ro'],
  ['YS-', 'sv'],
  ['YU-', 'rs'],
  ['YV-', 've'],
  ['Z3-', 'mk'],
  ['ZA-', 'al'],
  ['ZK-', 'nz'],
  ['ZP-', 'py'],
  ['ZS-', 'za'],
  ['ZT-', 'za'],
  ['ZU-', 'za'],
  ['3A-', 'mc'],
  ['3B-', 'mu'],
  ['3C-', 'gq'],
  ['3D-', 'sz'],
  ['3X-', 'gn'],
  ['4K-', 'az'],
  ['4L-', 'ge'],
  ['4O-', 'me'],
  ['4R-', 'lk'],
  ['4W-', 'tl'],
  ['4X-', 'il'],
  ['5A-', 'ly'],
  ['5B-', 'cy'],
  ['5H-', 'tz'],
  ['5N-', 'ng'],
  ['5R-', 'mg'],
  ['5T-', 'mr'],
  ['5U-', 'ne'],
  ['5V-', 'tg'],
  ['5W-', 'ws'],
  ['5X-', 'ug'],
  ['5Y-', 'ke'],
  ['6O-', 'so'],
  ['6V-', 'sn'],
  ['6W-', 'sn'],
  ['6Y-', 'jm'],
  ['7O-', 'ye'],
  ['7P-', 'ls'],
  ['7Q-', 'mw'],
  ['7T-', 'dz'],
  ['8P-', 'bb'],
  ['8Q-', 'mv'],
  ['8R-', 'gy'],
  ['9A-', 'hr'],
  ['9G-', 'gh'],
  ['9H-', 'mt'],
  ['9J-', 'zm'],
  ['9K-', 'kw'],
  ['9L-', 'sl'],
  ['9M-', 'my'],
  ['9N-', 'np'],
  ['9Q-', 'cd'],
  ['9U-', 'bi'],
  ['9V-', 'sg'],
  ['9Y-', 'tt'],
  // 1-char prefixes (must come last)
  ['C-', 'ca'],
  ['D-', 'de'],
  ['F-', 'fr'],
  ['G-', 'gb'],
  ['I-', 'it'],
  ['M-', 'im'],
  ['P-', 'kp'],
  ['Z-', 'zw'],
];

// Sort by prefix length descending so longest match wins
REGISTRATION_PREFIXES.sort((a, b) => b[0].length - a[0].length);

/**
 * Derive the country code from an aircraft registration string.
 *
 * @param {string} registration - e.g. "EI-IGM", ".EI-IGM", "N17133"
 * @returns {string|null} Lowercase ISO 3166-1 alpha-2 code, or null if unknown.
 */
export function getCountryFromRegistration(registration) {
  if (!registration || typeof registration !== 'string') return null;

  // Strip leading dot (some data sources prefix with '.')
  let reg = registration.trim();
  if (reg.startsWith('.')) {
    reg = reg.substring(1);
  }
  const upper = reg.toUpperCase();

  // --- Special sub-range handling for B- registrations ---
  // Hong Kong: B-H__, B-K__, B-L__
  // Macau:     B-M__
  // Otherwise: China
  if (upper.startsWith('B-')) {
    if (upper.length >= 3) {
      const third = upper[2];
      if (third === 'H' || third === 'K' || third === 'L') return 'hk';
      if (third === 'M') return 'mo';
    }
    return 'cn';
  }

  // --- US registrations: start with N, no hyphen ---
  if (upper.startsWith('N') && upper.length > 1 && upper[1] !== '-') {
    return 'us';
  }

  // --- French overseas territories still map to FR ---
  // F-O prefix is handled by the generic "F-" match below since both map to 'fr'.

  // --- Standard prefix lookup (longest match first) ---
  for (const [prefix, code] of REGISTRATION_PREFIXES) {
    if (upper.startsWith(prefix)) {
      return code;
    }
  }

  return null;
}
